import Splide from '@splidejs/splide';
import '@splidejs/splide/css';
import { screens } from '../../../../config/breakpoints';

const tabletWidth = screens.tablet.replace(/[^\d.-]/g, '');
const desktopWidth = screens.desktop.replace(/[^\d.-]/g, '');

function initSplide() {
  const splideContainer = [...document.querySelectorAll('.job-teaser .splide, .magazin-text-teaser .splide')];

  splideContainer.forEach(slider => {
    const options = {
      mediaQuery: 'min',
      gap: '20px',
      padding: 0,
      type: 'loop',
      perPage: 1,
      pagination: false,
      breakpoints: {
        [tabletWidth]: {
          perPage: 2,
        },
        [desktopWidth]: {
          perPage: 3,
        },
      },
      classes: {
        arrows: 'splide__arrows your-class-arrows',
        arrow: 'splide__arrow your-class-arrow',
        prev: 'splide__arrow--prev your-class-prev',
        next: 'splide__arrow--next your-class-next',
      },
    };

    const splide = new Splide(slider, options);
    splide.mount();
  });
}

document.addEventListener('DOMContentLoaded', initSplide);